// Crawlers and preview agents reach the panel's public routes (`/repartidor/...`,
// `/control-pedidos/self-service/...`) and stub the browser APIs they will not honor. Google's
// read-aloud agent replaces `navigator.serviceWorker.register` with a stub that rejects with a bare
// `Error: Rejected` — the whole content of Sentry issues 14Q / 129 / 17M (~200 events), whose most
// recent sampled event in all three carries
// `(compatible; Google-Read-Aloud; +https://support.google.com/webmasters/answer/1061943)`.
// No human is on the other end, so nothing those sessions report is actionable.
//
// This is deliberately NOT wired into `beforeSend`: the project's own `web-crawlers` inbound filter
// is already active in Sentry, and stacking a second, wider, client-side user-agent filter on top
// of it would drop events from EVERY family with no trace left in Issues. The only caller is
// `capturePwaRegistrationError`, which is the exact frame those three issues enter through.
//
// The `bot|crawler|spider|slurp` alternatives are boundary-guarded on purpose: a bare /bot/i also
// matches real phone models in the commerces' Android fleet (`CUBOT NOTE 20`), and muting Sentry
// for a real device is a far worse failure than keeping a crawler's event.
const NON_INTERACTIVE_UA =
  /(^|[^a-z])(bot|crawler|spider|slurp)([^a-z]|$)|Google-Read-Aloud|Google-InspectionTool|Chrome-Lighthouse|HeadlessChrome|facebookexternalhit/i;

export const isNonInteractiveAgent = (userAgent?: string): boolean => {
  const ua = userAgent ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent);
  return NON_INTERACTIVE_UA.test(ua);
};
